import { Pair, PairListResponse } from '../../types/pair';
import { handleApiError } from '../../utils/errorHandler';
import { pairApi } from './pairApi';

/**
 * Wrapper service for pair operations with centralized error handling
 * Provides simplified methods that handle success/error messages automatically
 */
export const pairApiWrapper = {
  // Get last N pair records with error handling
  getLastPairRecords: async (limit: number = 5, includeRelatedPairs: boolean = false, orderBy: 'id' | 'createdAt' = 'createdAt'): Promise<PairListResponse | null> => {
    return handleApiError(() => pairApi.getLastPairRecords(limit, includeRelatedPairs, orderBy));
  },

  // Get pair record by ID with error handling
  getPairRecordById: async (id: number): Promise<Pair | null> => {
    return handleApiError(() => pairApi.getPairRecordById(id));
  },

  // Get pair statistics with error handling
  getStats: async (): Promise<any | null> => {
    return handleApiError(() => pairApi.getStats());
  }
};
